import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { PublicAppErrorBoundary } from "@/components/PublicAppErrorBoundary";

const App = React.lazy(() => import("@/App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
const initialProductNode = document.getElementById("aramfix-initial-product");
if (initialProductNode) {
  try { window.__ARAMFIX_INITIAL_PRODUCT__ = JSON.parse(initialProductNode.textContent); } catch { window.__ARAMFIX_INITIAL_PRODUCT__ = null; }
}
let appReady = !document.getElementById("aramfix-prerender");
let stylesReady = Boolean(window.__ARAMFIX_STYLES_READY__) || !document.getElementById("aramfix-main-styles");
const revealApp = (force = false) => {
  if (!force && (!appReady || !stylesReady)) return;
  const serverLcp = document.querySelector("#aramfix-prerender [data-testid='prerender-product-image']");
  const clientLcp = document.querySelector("#root [data-testid='product-gallery-main-img']");
  if (serverLcp && clientLcp && !document.querySelector(".aramfix-lcp-overlay")) {
    serverLcp.removeAttribute("data-testid");
    serverLcp.className = "aramfix-lcp-overlay";
    clientLcp.style.visibility = "hidden";
    clientLcp.parentElement?.appendChild(serverLcp);
    let released = false;
    const releaseLcp = () => {
      if (released) return;
      released = true;
      clientLcp.style.visibility = "";
      serverLcp.remove();
    };
    window.addEventListener("pointerdown", releaseLcp, { once: true, passive: true, capture: true });
    window.addEventListener("keydown", releaseLcp, { once: true, capture: true });
    window.setTimeout(releaseLcp, 10000);
  }
  document.documentElement.classList.remove("aramfix-prerendering");
  document.getElementById("aramfix-prerender")?.remove();
};
window.__ARAMFIX_MARK_APP_READY__ = () => { appReady = true; revealApp(); };
window.__ARAMFIX_MARK_STYLES_READY__ = () => { stylesReady = true; revealApp(); };
window.setTimeout(() => revealApp(true), 8000);
root.render(
  <React.StrictMode>
    <PublicAppErrorBoundary><React.Suspense fallback={null}><App /></React.Suspense></PublicAppErrorBoundary>
  </React.StrictMode>,
);
